<template>
  <BaseButton ghost small @click="open">
    <span class="truncate"> Remove </span>
  </BaseButton>
</template>

<script>
import { contactAccountsClient } from '@/api/clients';

export default {
  props: {
    contactId: {
      type: String,
      required: true,
    },
    account: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showForm: false,
    };
  },
  methods: {
    async open() {
      this.$modal.show({
        component: () => import('Components/ContactAccounts/AccountRemoveModal.vue'),
        props: {
          action: async (accountId) => {
            try {
              await contactAccountsClient.destroy(this.contactId, accountId);

              return Promise.resolve();
            } catch (error) {
              return Promise.reject(error);
            }
          },
          account: this.account,
        },
        on: {
          'account-removed': (account) => {
            this.$emit('account-removed', account);
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
